var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-Project-Wizard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6666667,20 C26.6666667,23.6766667 23.6766667,26.6666667 20,26.6666667 C16.3233333,26.6666667 13.3333333,23.6766667 13.3333333,20 C13.3333333,16.3233333 16.3233333,13.3333333 20,13.3333333 C23.6766667,13.3333333 26.6666667,16.3233333 26.6666667,20 Z M40,8.33333333 L40,31.6666667 C40,36.2683333 36.27,40 31.6666667,40 L8.33333333,40 C3.73166667,40 0,36.2683333 0,31.6666667 L0,8.33333333 C0,3.73166667 3.73166667,0 8.33333333,0 L31.6666667,0 C36.27,0 40,3.73166667 40,8.33333333 Z M30,20 C30,14.4783333 25.5216667,10 20,10 C14.4783333,10 10,14.4783333 10,20 C10,25.5216667 14.4783333,30 20,30 C25.5216667,30 30,25.5216667 30,20 Z M35,6.66666667 C35,5.74666667 34.2533333,5 33.3333333,5 C32.4133333,5 31.6666667,5.74666667 31.6666667,6.66666667 C31.6666667,7.58666667 32.4133333,8.33333333 33.3333333,8.33333333 C34.2533333,8.33333333 35,7.58666667 35,6.66666667 Z",
    id: "Shape-Copy",
    fill: "#868686",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.8576f267.svg";
export { ForwardRef as ReactComponent };